// types
import type { TreatmentDeviationResponse } from 'generated/index';
import type { TFunction } from 'i18next';

// One treatment deviation as a single readable line: who it concerns, what is wrong, and the
// treatment a re-export would send. The exported treatment id itself stays out — it is an
// Ecaris/Reflex identifier that means nothing to the secretariat reading it.
export const formatTreatmentDeviation = (
  deviation: TreatmentDeviationResponse,
  t: TFunction
): string => {
  const reason = t(`treatmentDeviation.values.${deviation.type}`);
  const programName = deviation.derivedTreatment?.programName;
  const description = programName ? `${reason} (${programName})` : reason;

  return `${deviation.careReceiverName ?? ''}: ${description}`;
};

// Every deviating care receiver on one occurrence, for one destination. A group appointment lists
// them all, which is why they are joined rather than reduced to the first one.
export const formatTreatmentDeviations = (
  deviations: TreatmentDeviationResponse[] | undefined,
  t: TFunction
): string =>
  (deviations ?? [])
    .map((deviation) => formatTreatmentDeviation(deviation, t))
    .join('; ');
